import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Popover from '@marvelapp/marvel-ui/popover';
import Paragraph from '@marvelapp/marvel-ui/paragraph';

import Tick from '../Icons/Tick/index';
import styles from './PlanFeatureList.css';

function PlanFeatureList({ features }) {
  return (
    <div className={styles.grid}>
      {features.map(({ description, toolTip }, index) => {
        const firstFeature = index === 0;
        const containerClasses = cx({
          [styles.isLast]: index !== features.length - 1,
        });
        const featureClasses = cx({
          [styles.bold]: firstFeature,
          [styles.light]: !firstFeature,
          [styles.featureText]: true,
        });

        const triggerClasses = cx({
          ...featureClasses,
          [styles.featureText]: true,
        });

        return (
          <div key={description} className={containerClasses}>
            <div className={styles.container}>
              <div className={styles.icon}>
                <Tick />
              </div>
              <div className={styles.feature}>
                {toolTip ? (
                  <Popover showOnHover type="dark" width={280}>
                    <Popover.Trigger>
                      <span className={triggerClasses}>{description}</span>
                    </Popover.Trigger>
                    <Popover.Content>
                      <div className="paddingTopBottom-xs paddingLeftRight-s">
                        <Paragraph size="s" color="white">
                          {toolTip}
                        </Paragraph>
                      </div>
                    </Popover.Content>
                  </Popover>
                ) : (
                  <span className={featureClasses}>{description}</span>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

PlanFeatureList.propTypes = {
  features: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      toolTip: PropTypes.string,
    })
  ),
};

export default PlanFeatureList;



// WEBPACK FOOTER //
// ./src/components/modules/Pricing/PlanFeatureList/index.js